import React from "react";
import { connect } from "react-redux";
import { SelectBox } from 'devextreme-react/select-box';
import { Button } from 'devextreme-react/button';
import routes from "../../../assets/apiRoutes.json"
import TextBox from 'devextreme-react/text-box';
import axios from "axios";
import notify from 'devextreme/ui/notify';
import DataSource from "devextreme/data/data_source";
import ArrayStore from 'devextreme/data/array_store';
import {
    Validator,
    RequiredRule,
    StringLengthRule
} from 'devextreme-react/validator';
import NumberBox from 'devextreme-react/number-box';
import ValidationSummary from 'devextreme-react/validation-summary';
import TextArea from 'devextreme-react/text-area';
let accessToken = '';
const orchardCodesSelectBox = React.createRef();
const blockCodesSelectBox = React.createRef();
class AddOrchardCode extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            code: "",
            name: "",
            status: "A",
            comment: ""            
        };
        accessToken = props.oidc.user.access_token;
        this.SaveRecord = this.SaveRecord.bind(this);        
        this.Reset = this.Reset.bind(this);
        this.statusArr = [{ id: 1, name: 'Active', value: 'A' }, { id: 2, name: 'Inactive', value: 'I' }];
    }
    componentDidMount() {
        
    }
  
 
    Reset() {
        this.setState({
            code: "",
            name: "",
            status: "A",
            comment: ""  
        });
    }
    SaveRecord(e) {
        e.preventDefault();
        var rqst = this.state;
        axios.post(`${window._env_.REACT_APP_APIS}/${routes.Orchard.InsertOrchardCode }`, rqst,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            })
            .then((res) => {
                if (res.data == "Orchard code already exist.") {
                    notify({
                        message: 'Orchard code already exist!',
                        width: 100,
                    }, 'error', 2000);
                }
                else {
                    notify({
                        message: 'Record Saved!',
                        width: 100,
                    }, 'success', 2000);
                    this.props.parentCallback();
                    this.Reset();
                }
            }).catch((err) => {
                notify({
                    message: 'Couldnt Save Data!!',
                    width: 450,
                }, 'error', 2000);
            });
    }
    render() {
        return (
            <div>                
                <form onSubmit={(e) => this.SaveRecord(e)}>                
                    <div className="row">
                        <label htmlFor="orchard-code" className="field-label">
                            Code
                        </label>
                        <TextBox
                            id="orchard-code"
                            className="input-field"
                            type="text"
                            placeholder="Enter Orchard Code"
                            onValueChanged={(data) => this.setState({ code: data.value })}
                            name="orchard-code"
                            maxLength={12}
                            value={this.state.code}>
                            <Validator>
                                <RequiredRule message="Code(Orchard) is required." />
                                <StringLengthRule message="Code must have at least 3 chracters and maximum 12" min={3} max={12} />
                            </Validator>
                        </TextBox>
                    </div>
                    <div className="row">
                        <label htmlFor="orchard-name" className="field-label">
                            Name
                        </label>
                        <TextBox
                            id="orchard-name"
                            className="input-field"
                            type="text"
                            placeholder="Enter Description"
                            onValueChanged={(data) => this.setState({ name: data.value })}
                            name="orchard-name"
                            value={this.state.name}>
                            <Validator>
                                <StringLengthRule message="Name must have at least 3 chracters and maximum 40" min={3} max={50} />
                            </Validator>
                        </TextBox>
                    </div>
                    <div className="row">
                        <label htmlFor="status-sb" className="field-label">
                            Status
                        </label>
                        <SelectBox
                            displayExpr="name"
                            valueExpr="value"
                            dataSource={this.statusArr}
                            name="status-sb"
                            className="w-100"
                            defaultValue={"A"}
                            value={this.state.status}
                            onValueChanged={(data) => this.setState({ status: data.value })}
                        />
                    </div>                
                    <div className="row">
                        <label htmlFor="orchard-comment" className="field-label">
                            Comment
                        </label>
                        <TextArea
                            id="orchard-comment"
                            className="input-field"
                            placeholder="Enter Comment"
                            onValueChanged={(data) => this.setState({ comment: data.value })}
                            name="orchard-comment"
                            value={this.state.comment}
                            height={90}
                        />
                    </div>          
                                 
                    <div className="row">
                        <div className="col-md-12" style={{ marginTop: "10px", marginBottom: "10px" }}>
                            <ValidationSummary id="summary" />
                            <div className="">
                                <Button
                                    text="Save Record"
                                    type="default"
                                    useSubmitBehavior={true}
                                    stylingMode="contained">
                                </Button>
                                <Button
                                    onClick={this.Reset}
                                    style={{marginLeft:'10px'}}
                                    text="Reset"
                                    useSubmitBehavior={false}
                                    stylingMode="contained">
                                </Button>
                            </div>
                        </div>
                    </div>
                </form >
            </div >
        );
    }
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(AddOrchardCode);